module.exports = __webpack_public_path__ + "zrm-sample-rentals-nearby@2x-3yQsGY4.png";